import React from 'react';
import Types from './Types';
import Rounded from './Rounded';
import ButBadges from './ButBadges';

const BadgeComponent = () => {
    return (
      <div className="m-3">
        <h3>Badges</h3>
        <Types />
        <Rounded />
        <ButBadges />
      </div>
    );
  };
  
  export default BadgeComponent;